export const hashStringToNumber = (str: string): number => {
  return Array.from(str).reduce((acc, char) => acc + char.charCodeAt(0), 0)
}
